/* eslint-disable react/no-multi-comp */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import { NavigationMenuGroupType } from '../../types'
import ExternalLink from '../../../external-link'
import {
  CHINA_WESTFIELD_URLS,
  GIFT_CARD_MENU_TEXT,
  WESTFIELD_PLUS_URL,
} from '../../../../constants'
import analyticsUtils from '../../../../helpers/analytics-utils'
import { parseHostname } from '../../../../helpers/url'
import style from './index.module.scss'

const isChinaWestfieldUrl = url =>
  CHINA_WESTFIELD_URLS.includes(parseHostname(url))

const NavigationGroup = ({
  navigationGroup: { title, items },
  onClick,
  isMenuOpen,
  menuIndex,
}) => {
  const renderItem = item => {
    const isGiftCard = item.label.toLowerCase() === GIFT_CARD_MENU_TEXT
    const isWestfieldPlus = item.url.indexOf(WESTFIELD_PLUS_URL) > -1
    const isChinaWestfield = isChinaWestfieldUrl(item.url)
    const isExternal = isGiftCard || isWestfieldPlus || isChinaWestfield
    let linkProps = {}

    if (isExternal) {
      linkProps = {
        url: item.url,
        rel: 'noopener',
      }
      if (isGiftCard) {
        linkProps = {
          ...linkProps,
          eventCategory: analyticsUtils.categories.GIFTCARD_CLICK,
          eventAction: analyticsUtils.actions.GIFTCARD_NAV_CLICK,
        }
      } else if (isWestfieldPlus) {
        linkProps = {
          ...linkProps,
          eventCategory: analyticsUtils.categories.WESTFIELD_PLUS_CLICK,
          eventAction: analyticsUtils.actions.WESTFIELD_PLUS_NAV_CLICK,
        }
      } else if (isChinaWestfield) {
        linkProps = {
          ...linkProps,
          eventCategory: analyticsUtils.categories.CHINA_WESTFIELD_CLICK,
          eventAction: analyticsUtils.actions.CHINA_WESTFIELD_NAV_CLICK,
        }
      }
    } else {
      linkProps = {
        to: item.url,
        'aria-label': `Go to ${item.label}`,
        onClick: () => onClick(null),
      }
    }

    const Wrapper = isExternal ? ExternalLink : Link

    return (
      <Wrapper
        key={item.url}
        className={classNames(style.link, {
          [style.menuOpenLink]: isMenuOpen,
        })}
        {...linkProps}
      >
        {item.label}
      </Wrapper>
    )
  }

  return (
    <div className={style.NavigationGroup}>
      <button
        className={classNames(style.title, { [style.active]: isMenuOpen })}
        role="menuitem"
        aria-label={`Open ${title}`}
        onClick={() => onClick(menuIndex)}
      >
        {title}
        <Icon
          type={isMenuOpen ? 'chevron-up' : 'chevron-down'}
          size="small"
          className={style.navigationCarrot}
          role="presentation"
        />
      </button>
      <div
        className={classNames(style.childrenWrapper, {
          [style.menuOpen]: isMenuOpen,
        })}
        role="menu"
      >
        {items.map(renderItem)}
      </div>
    </div>
  )
}

NavigationGroup.propTypes = {
  navigationGroup: NavigationMenuGroupType.isRequired,
  isMenuOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  menuIndex: PropTypes.number.isRequired,
}

export default NavigationGroup
